export default __webpack_public_path__ + "static/media/014-detective.f88773ea.svg";